import React, { useState } from "react";
import { Modal, Tabs, Tab, Button } from "react-bootstrap";
import BasicInfoTab from "./AddnewModals/BasicInfoTab";
import AddressTab from "./AddnewModals/AddressTab";
import SocialTab from "./AddnewModals/SocialTab";
import AddAccessTab from "./AddnewModals/AddAccessTab";




export default function CompanyModal({ show, setShow }) {
  const [key, setKey] = useState("basic");

  return (
    <Modal
      show={show}
      onHide={() => setShow(false)}
      size="lg"
      centered
    >
      <Modal.Header closeButton>
        <Modal.Title>Add New Company</Modal.Title>
      </Modal.Header>

      <Modal.Body>
        <Tabs
          activeKey={key}
          onSelect={(k) => setKey(k)}
          className="custom-tabs mb-3"
        >
          <Tab eventKey="basic" title="Basic Information">
            <BasicInfoTab />
          </Tab>

          <Tab eventKey="address" title="Address">
            <AddressTab />
          </Tab>

          <Tab eventKey="social" title="Social Profiles">
            <SocialTab />
          </Tab>

          <Tab eventKey="access" title="Access">
            <AddAccessTab />
          </Tab>
        </Tabs>
      </Modal.Body>

      <Modal.Footer>
        <Button variant="light" onClick={() => setShow(false)}>
          Cancel
        </Button>
        <Button className="btn-orange">Save</Button>
      </Modal.Footer>
    </Modal>
  );
}